import {
  FETCH_STOCKQUOTE_REQUEST,
  FETCH_STOCKQUOTE_SUCCESS,
  FETCH_STOCKQUOTE_ERROR,
} from '../../../actions/widget/stock'
import { IDLE, FETCHED, FETCHING, ERROR } from '../../../constants/fetchStates'

const stockQuote = (state = { status: IDLE }, action) => {
  switch (action.type) {
    case FETCH_STOCKQUOTE_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case FETCH_STOCKQUOTE_SUCCESS:
      return {
        ...state,
        items: action.payload,
        status: FETCHED
      }
    case FETCH_STOCKQUOTE_ERROR:
      return {
        ...state,
        error: action.error,
        status: ERROR
      }
    default:
      return state
  }
}

export default stockQuote
